module.exports = __webpack_public_path__ + "static/media/Maginex.00b26681.md";